<template lang="pug">
div.wrap-module-edit-profile.f.fc
  div.edit-profile-content.pt12.pb30
    span.block.text-center.mb20 プロフィールの設定
    div.f.fc.mb30
      div.user-icon-img.relative
        v-avatar(size="120px")
          v-img(:src="iconPhotoURL")
        div.change-icon.absolute.f.fh.px6.py6.r4.b4
          ItemUserIconChanger(@updateImg="setIconPhotoURL" :uid="user.uid")
    div.wrap-profile.mb20
      v-text-field(v-model="name"
        label="名前 *" placeholder="名前を入力"
        :hint="`文字数：${this.name.length}/80`"
        persistent-hint persistent-placeholder outlined).mb20
      v-textarea(v-model="profile"
        :hint="`文字数：${this.profile.length}/200`"
        label="プロフィール" placeholder="プロフィールを入力"
        @keydown.enter.exact.prevent
        @keydown.enter.prevent
        persistent-hint persistent-placeholder outlined)
    div.wrap-web-sites
      v-text-field(label="Twitter"
        :placeholder="prefixes.twitter"
        v-model="twitter"
        persistent-placeholder outlined)
      v-text-field(label="TickTok"
        :placeholder="prefixes.ticktock"
        v-model="ticktock"
        persistent-placeholder outlined)
      v-text-field(label="Instagram"
        :placeholder="prefixes.instagram"
        v-model="instagram"
        persistent-placeholder outlined)
      v-text-field(label="VroidHub"
        :placeholder="prefixes.vroidhub"
        v-model="vroidhub"
        persistent-placeholder outlined)
      v-text-field(label="Sketchfab"
        :placeholder="prefixes.sketchfab"
        v-model="sketchfab"
        persistent-placeholder outlined)
      v-text-field(label="Web"
        :placeholder="prefixes.web"
        v-model="web"
        persistent-placeholder outlined)
    div
      Button(label="保存" :action="saveProfile" :active="isValid" :isSaving="isSaving")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-edit-profile {
  padding-top: $header_height;
  .edit-profile-content {
    max-width: 420px;
    width: $base_width_percent;
    .user-icon-img {
      .change-icon {
        background: $active_color;
        border-radius: 50%;
        box-shadow: $box-shadow;
      }
    }
  }
}
</style>

<script>
// import database from '@/database'
import { auth, functions } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Button from '@/components/shared/Button'
import ItemUserIconChanger from '@/components/item/ItemUserIconChanger'

export default {
  components: {
    Button,
    ItemUserIconChanger
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    isValid () {
      return this.iconPhotoURL
       && (0 < this.name.length && this.name.length < 80)
       && (0 <= this.profile.length && this.profile.length < 200)
       && (this.twitter === '' || this.twitter.includes(this.prefixes.twitter) || this.twitter.includes(this.wwwValidations.twitter))
       && (this.ticktock === '' || this.ticktock.includes(this.prefixes.ticktock) || this.ticktock.includes(this.wwwValidations.ticktock))
       && (this.instagram === '' || this.instagram.includes(this.prefixes.instagram) || this.instagram.includes(this.wwwValidations.instagram))
       && (this.vroidhub === '' || this.vroidhub.includes(this.prefixes.vroidhub) || this.vroidhub.includes(this.wwwValidations.vroidhub))
       && (this.sketchfab === '' || this.sketchfab.includes(this.prefixes.sketchfab) || this.sketchfab.includes(this.wwwValidations.sketchfab))
       && (this.web === '' || this.web.includes('https://') || this.web.includes('http://'))
    }
  },
  data () {
    return {
      iconPhotoURL: '',
      name: '',
      profile: '',
      twitter: '',
      ticktock: '',
      instagram: '',
      vroidhub: '',
      sketchfab: '',
      web: '',
      prefixes: {
        twitter: 'https://twitter.com/',
        ticktock: 'https://www.tiktok.com/',
        instagram: 'https://instagram.com/',
        vroidhub: 'https://hub.vroid.com/users/',
        sketchfab: 'https://sketchfab.com/',
        web: 'https://mypage.me'
      },
      wwwValidations: {
        twitter: 'https://www.twitter.com/',
        ticktock: 'https://www.tiktok.com/',
        instagram: 'https://www.instagram.com/',
        vroidhub: 'https://www.hub.vroid.com/users/',
        sketchfab: 'https://www.sketchfab.com/',
      },
      isSaving: false
    }
  },
  created () {
    this.iconPhotoURL = this.user.iconPhotoURL
    this.name = this.user.name
    this.profile = this.user.profile
    if (this.user.websites) {
      this.twitter = this.user.websites.twitter ? this.user.websites.twitter : ''
      this.ticktock = this.user.websites.ticktock ? this.user.websites.ticktock : ''
      this.instagram = this.user.websites.instagram ? this.user.websites.instagram : ''
      this.vroidhub = this.user.websites.vroidhub ? this.user.websites.vroidhub : ''
      this.sketchfab = this.user.websites.sketchfab ? this.user.websites.sketchfab : ''
      this.web = this.user.websites.web ? this.user.websites.web : ''
    }
  },
  methods: {
    async saveProfile () {
      if (!this.isValid) return
      this.isSaving = true

      // const userObj = {
      //   name: this.name,
      //   profile: this.profile,
      //   websites: {
      //     twitter: this.twitter,
      //     ticktock: this.ticktock,
      //     instagram: this.instagram,
      //     vroidhub: this.vroidhub,
      //     sketchfab: this.sketchfab,
      //     web: this.web
      //   },
      //   iconPhotoURL: this.iconPhotoURL,
      //   updatedAt: new Date()
      // }
      // await database.userCollection().update(this.uid, userObj)
      const userProfile = {
        name: this.name,
        profile: this.profile,
        websites: {
          twitter: this.twitter,
          ticktock: this.ticktock,
          instagram: this.instagram,
          vroidhub: this.vroidhub,
          sketchfab: this.sketchfab,
          web: this.web
        },
        iconPhotoURL: this.iconPhotoURL,
        // updatedAt: new Date()
      }
      // 
      const updateUserProfile = functions.httpsCallable('updateUserProfile')
      await updateUserProfile({ ...userProfile })
        .then(result => result.data)

      await this.sleep(1000)
      this.$root.$emit('showNavigationMessage', {
        message: '保存しました', showOK: true
      })

      this.isSaving = false
    },
    setIconPhotoURL (imgURL) {
      this.iconPhotoURL = imgURL
    }
  }
}
</script>
